module.exports = __webpack_public_path__ + "img/Honig-aus-2021-440.8226f4f1.jpg";